var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isShowMask)?_c('img',{staticClass:"mask",attrs:{"src":_vm.postMask}}):_vm._e(),_vm._v(" "),_c('iframe',{staticClass:"ReplayIframe",attrs:{"frameborder":"no"}}),_vm._v(" "),_c('LoadingView',{attrs:{"finished":_vm.finished},on:{"clickBack":_vm.clickBack}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a4977aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/visionTrainTrack/ReplayIframe.vue
// module id = null
// module chunks = 